{
  "11a6767d5674c7e4": "Done",
  "19766ed6ccb2f4a3": "Cancel",
  "4a101ec79a35b0a2": "Submit feedback",
  "4d3f06fccd60a383": "We appreciate you taking the time to help us improve.",
  "6d62dfbd9b4caa21": "Share your feedback",
  "814f4ed2d5bd33e3": "Contact support",
  "85ffb01c5394bf41": "Thanks for your feedback",
  "a7e56c38fbd8c267": "Tell us more...",
  "af015af1fd67fbdf": "Sorry to hear that",
  "f05abe0730c3b196": "Let us know how we can improve."
}
